import close from "./close.svg";
export function CloseIcon(props: { label?: string }) {
  return <img src={close} alt={props.label ?? "Close"} />;
}
